var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6C1 6.9889 1.29324 7.9556 1.84265 8.77785C2.39206 9.60009 3.17295 10.241 4.08658 10.6194C5.00021 10.9978 6.00555 11.0969 6.97545 10.9039C7.94535 10.711 8.83627 10.2348 9.53553 9.53553C10.2348 8.83627 10.711 7.94535 10.9039 6.97545C11.0969 6.00555 10.9978 5.00021 10.6194 4.08658C10.241 3.17295 9.60009 2.39206 8.77785 1.84265C7.9556 1.29324 6.9889 1 6 1C4.60219 1.00526 3.26054 1.55068 2.25556 2.52222L1 3.77778M1 3.77778V1M1 3.77778H3.77778",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.9fd8cef47c2d363884129c50376bdb50.svg";
export { ForwardRef as ReactComponent };